import React, { FC } from "react";
import { PlusIcon } from "@primer/octicons-react";

interface CreateEventCardProps {
  href: string;
  label?: string;
  subtitle?: string;
}

// GR-1695: leading card in the events card grid; a dashed "create event"
// affordance sized identically to the event cards (it shares .event-card-inner
// box sizing). Rest + hover (blue) states live in custom-event-card.scss.
// GR-1702: an optional subtitle line heightens the CTA (reused by the My
// Requests grid's "Create New Event Request" card).
export const CreateEventCard: FC<CreateEventCardProps> = ({
  href,
  label = "Create New Event",
  subtitle,
}) => (
  <a href={href} className="event-card-inner event-create-card test-create-event-card">
    <span className="event-create-card-icon" aria-hidden="true">
      <PlusIcon size={24} />
    </span>
    <span className="event-create-card-text">
      <span className="event-create-card-label">{label}</span>
      {subtitle && <span className="event-create-card-subtitle">{subtitle}</span>}
    </span>
  </a>
);
